import { Observable } from "rxjs";

import { post , get, put} from "@utils/axios";
import sessionService from "./session.service";

class ReportService {

  getReportTableData({ payload }: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/getReportTableData`, {
      ...payload,
    });
  }

  getColumnsList(reportName : string): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/column-list?pageName=${reportName}`);
  }

  downloadReport({reportName, columns , sortByCol , sortType , filters, topFilters} : any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/downloadReport` , {
      reportName,
      columns,
      sortByCol,
      sortType,
      topFilters,
      filters
    });
  }

  updateColumns(columns: any[], reportName: string): Observable<any> {
    return put(`${sessionService.getClient()?.appServiceUrl}/patient/column-preference?pageName=${reportName}`, { columns: columns });
  }

  downloadNotesReport(isMemberDetailsView: any, memberId?: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/download-notes`, {
      isMemberDetailsView,
      memberId
    });
  }

  getHCCScoreCardData(payload: {reportPageName: string; startDate?: any; endDate?: any; year?: number}): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/hccReportScoreCard`, {
      payload
    });
  }

  getChronicBreakdownChartData(year: any, state: any, city: any, healthPlan: any, pcpVendor: any, pcpId: any, chronicCondition: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/chronicBreakdownReport`, {year, state, city, healthPlan, pcpVendor, pcpId, chronicCondition});
  }

  exportChronicBreakdown(year: any, state: any, city: any, healthPlan: any, pcpVendor: any, pcpId: any, chronicCondition: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/downloadChronicBreakdownReport`, {year, state, city, healthPlan, pcpVendor, pcpId, chronicCondition});
  }

  getChronicBreakdownReportPatientIds(year: any, state: any, city: any, healthPlan: any, pcpVendor: any, pcpId: any, chronicName: any, chronicSplitName?: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/chronicBreakdownReportPatientIds`, {year, state, city, healthPlan, pcpVendor, pcpId, chronicName, chronicSplitName});
  }

  exportSourceData(reportName: string): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/supplemental/export-source-data`, {reportName});
  }
}

export default new ReportService();